import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { IdUploadModalComponent } from './id-upload-modal.component';

@NgModule({
  declarations: [
    IdUploadModalComponent
  ],
  providers: [
  ],
  imports: [
    BrowserModule,
    CommonModule,
  ],
  exports: [
    IdUploadModalComponent,
  ]
})
export class IdUploadModalModule {}
